/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { LeverageWithdrawOptions, LeverageWithdrawResponses } from '../types/LeverageWithdraw'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Withdraw leverage for a specific asset
 * {@link /v1/leverage/withdraw}
 */
export function leverageWithdraw<ThrowOnError extends boolean = true>(
  options: Options<LeverageWithdrawOptions, ThrowOnError>,
): Unwrappable<RequestResult<LeverageWithdrawResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/leverage/withdraw',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<LeverageWithdrawResponses, ThrowOnError>>,
  )
}
